import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <UpdatesSection />
        <FAQSection />
        <MediaSection />
        <CardsSection />
        <TopicsSection />
        <CarouselSection />
        <RankingSection />
        <AppSection />
        <IndexSection />
        <CommentsSection />
        <AboutSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}